module.exports = __webpack_public_path__ + "static/media/offerEmtry_screen.3d1c7fa3.jpg";